export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6733.395f49b9.jpg";